export const SET_LOADING = 'SET_LOADING';

export const setLoading = (loading) => {
    return {
        type: SET_LOADING,
        payload: loading
    }
};
